import styled from 'styled-components';

import { COLORS } from 'theme';

import { StyledCardContent } from './Card.styles';

export const CardHeaderContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m1};
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s2};
`;

export const CardContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.m1};
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: 1px solid ${COLORS.black08};
  ${({ $hasError }) => $hasError && `border-color: ${COLORS.red};`}
  ${({ $isHighlighted }) => $isHighlighted && `border-color: ${COLORS.blue};`}
  ${({ $isClickable }) => $isClickable && 'cursor: pointer;'}
  color: ${COLORS.kinetikBlack};

  > ${CardHeaderContainer}:first-child
    + ${StyledCardContent},
    > ${CardHeaderContainer}:first-child
    + *
    ${StyledCardContent} {
    //different padding for content section if the container card contains both header and content
    padding-top: ${({ theme }) => theme.spacing.s4};
  }
`;

export const CardTitle = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s2};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ $size }) => $size};
  line-height: ${({ theme }) => theme.lineHeight.h3};
`;

export const CardDivider = styled.div`
  margin-inline: ${({ theme }) => theme.spacing.m1};
  margin-block: ${({ theme }) => theme.spacing.s4};
  width: calc(100% - ${({ theme }) => theme.spacing.l2});
  height: 1px;
  background-color: ${COLORS.black08};
`;

export const CardParagraph = styled.div`
  padding-inline: ${({ theme }) => theme.spacing.m1};
  padding-block: ${({ theme }) => theme.spacing.s2};
  font-size: ${({ theme }) => theme.fontSize.body1};
  line-height: ${({ theme }) => theme.lineHeight.body1};
  color: ${COLORS.black50};
`;

export const CardPaddedRow = styled.div`
  padding-inline: ${({ theme }) => theme.spacing.m1};
`;

export const CardRow = styled(CardPaddedRow)`
  padding-block: ${({ theme }) => theme.spacing.s2};
  display: flex;
  align-items: center;
`;

export const CardDataRow = styled(CardRow)`
  justify-content: space-between;
`;

export const CardDataIconValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s3};
`;

export const CardDataValue = styled.span`
  color: ${COLORS.kinetikBlack};
`;

export const CardDataLabel = styled.span`
  color: ${({ color }) => color || COLORS.black60};
  font-size: ${({ theme }) => theme.fontSize.h6};
  line-height: ${({ theme }) => theme.lineHeight.h6};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: right;
  text-wrap: nowrap;
`;

export const CardDataLocationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  :not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing.m1};

    ::before {
      content: '';
      position: absolute;
      width: 1px;
      height: ${({ theme }) => theme.spacing.s4};
      border-radius: 0.5px;
      background-color: ${COLORS.black10};
      left: 9.5px; // Half of the icon width
      top: -${({ theme }) => theme.spacing.m1};
    }
  }
`;

export const CardDataLocationAddressText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.body2};
  line-height: ${({ theme }) => theme.lineHeight.body2};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;

export const CardDoubleColumnRow = styled.div`
  padding-inline: ${({ theme }) => theme.spacing.m1};
  padding-block: ${({ theme }) => theme.spacing.s2};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.s4};
`;
